import Vue from 'vue';
import Vuex from 'vuex';
import window from 'govmo-common/src/store/modules/window';

Vue.use(Vuex);
export default new Vuex.Store({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    window,
  },
});
